<template>
  <div class="mymsg big">
    <!-- 添加特色科室 -->
    <el-dialog
      title="添加特色科室"
      :visible.sync="dialogadd"
      width="600px"
      style="text-align:left"
    >
      <div class="dialog">
        <div style="font-size:16px;margin-bottom:16px;font-weight:600">特色科室名称</div>
        <el-input
          v-model="department_name_add"
          placeholder="请输入10位以内汉字或字符"
          maxlength="10"
        ></el-input>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="dialogadd = false">取 消</el-button>
        <el-button
          type="primary"
          @click="addDepartment"
        >确 定</el-button>
      </div>
    </el-dialog>
    <div class="page_title">特色科室列表</div>
    <div style="padding:20px;border-radius:5px;">
      <div class="container">
        <div>
          <div class="box">
            <div class="searchbox">
              <div>
                <span>特色科室名称</span>
                <el-input
                  v-model="department_name"
                  style="width:220px;margin:0 20px 0 10px"
                  @input="search"
                  clearable
                ></el-input>

                <el-button
                  type="info"
                  style="background-color:#eceff2;;color:#747981;"
                  @click="search"
                  size="medium"
                >查询</el-button>
              </div>
              <el-button
                type="primary"
                @click="dialogadd = true;department_name_add=''"
                :disabled="module_id_array[0]?!module_id_array.includes('274'):false"
                icon="el-icon-plus"
              >添加科室</el-button>
            </div>

            <div style="border: solid 1px #c9cbd6;">
              <el-table
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%;min-width:1000px;"
                :header-cell-style="{background:'#F5F5F5'}"
              >
                <el-table-column
                  label="特色科室名称"
                  prop="department_name"
                ></el-table-column>

                <el-table-column
                  label="科室说明"
                  prop="introduction"
                ></el-table-column>
                <el-table-column
                  label="医生人数"
                  prop="doctor_count"
                ></el-table-column>

                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      @click="toDetail(scope.row.department_id)"
                      :disabled="module_id_array[0]?!module_id_array.includes('273'):false"
                    >查看详情</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div>
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="10"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalNum"
                style="margin:20px 0"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import clinic from '../../../api/clinic';
import platform from '../../../api/platform';
import moment from 'moment';
import axios from '../../../service/axios/axios';
import _ from 'lodash';
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      department_name: '',
      department_name_add: '',
      dialogadd: false
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    admin_id() {
      return this.$store.state.login.userInfo.admin_id;
    }
  },
  methods: {
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        department_name: this.department_name
      };
      clinic.getSpecialDepartmentList(data).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.list;
          this.totalNum = res.data.total;
        }
      });
    },
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //添加特色药房
    addDepartment() {
      if (!this.department_name_add) {
        this.$message.error('请输入科室名称');
        return false;
      }
      let data = {
        department_id: 0,
        department_name: this.department_name_add
      };
      clinic.saveSpecialDepartmentInfo(data).then((res) => {
        if (res.code == 0) {
          this.$message.success('添加成功');
          this.dialogadd = false;
          this.getList();
        }
      });
    },
    toDetail(department_id) {
      this.$router.push({
        path: 'departmentdetail',
        query: {
          department_id
        }
      });
    }
  },
  created() {
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}

.box {
  width: 100%;
  box-sizing: border-box;
  padding: 20px;
  .searchbox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }
}
.dialog {
  padding: 30px 30px 0;
}
</style>

